// extracted by mini-css-extract-plugin
export default {"container":"Main_container__HXL-8","title":"Main_title__BRoM+","line":"Main_line__e1K+P","newEvents":"Main_newEvents__REWlq"};